export default __webpack_public_path__ + "static/media/screen_editor.a4534b5c.svg";